import { vaultFetch } from './vault-api-core.ts'

export type VaultDaemonStatus = 'pending' | 'approved' | 'revoked'

export interface VaultDaemonRow {
  id: string
  rootId: string
  harnessId: string
  harnessName: string
  hostLabel: string
  profile: string
  daemonPubkey: string
  status: VaultDaemonStatus
  kekVersionHeld: number | null
  needsRedelivery: boolean
  lastSeenAt: string | null
  createdAt: string
  approvedBy: string | null
  [key: string]: unknown
}

// ── daemons ─────────────────────────────────────────────────────────────
export async function listDaemons(rootId: string): Promise<VaultDaemonRow[]> {
  const { daemons } = await vaultFetch<{ daemons: VaultDaemonRow[] }>(
    `/vault/admin/${rootId}/daemons`,
  )
  return daemons
}

export function approveDaemon(
  rootId: string,
  daemonId: string,
  body: { wrappedKek: string; kekVersion: number },
): Promise<{ ok: true }> {
  return vaultFetch<{ ok: true }>(
    `/vault/admin/${rootId}/daemons/${daemonId}/approve`,
    { method: 'POST', body: JSON.stringify(body) },
  )
}

export function redeliverKek(
  rootId: string,
  daemonId: string,
  body: { wrappedKek: string; kekVersion: number },
): Promise<{ daemonId: string; kekVersion: number }> {
  return vaultFetch<{ daemonId: string; kekVersion: number }>(
    `/vault/admin/${rootId}/daemons/${daemonId}/redeliver`,
    { method: 'POST', body: JSON.stringify(body) },
  )
}

export function revokeDaemon(
  rootId: string,
  daemonId: string,
): Promise<{ ok: true }> {
  return vaultFetch<{ ok: true }>(
    `/vault/admin/${rootId}/daemons/${daemonId}/revoke`,
    { method: 'POST' },
  )
}
